import './QrModal.scss';

export { default } from './QrModal';
